var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87636 5.36364L10.1818 7.66182C10.1818 7.62545 10.1818 7.58182 10.1818 7.54545C10.1818 6.9668 9.95195 6.41185 9.54278 6.00268C9.13361 5.59351 8.57865 5.36364 8 5.36364C7.95636 5.36364 7.92 5.36364 7.87636 5.36364ZM4.74909 5.94545L5.87636 7.07273C5.84 7.22545 5.81818 7.37818 5.81818 7.54545C5.81818 8.12411 6.04805 8.67906 6.45722 9.08823C6.86639 9.4974 7.42135 9.72727 8 9.72727C8.16 9.72727 8.32 9.70545 8.47273 9.66909L9.6 10.7964C9.11273 11.0364 8.57455 11.1818 8 11.1818C7.03558 11.1818 6.11065 10.7987 5.4287 10.1168C4.74675 9.4348 4.36364 8.50988 4.36364 7.54545C4.36364 6.97091 4.50909 6.43273 4.74909 5.94545ZM0.727273 1.92364L2.38545 3.58182L2.71273 3.90909C1.51273 4.85455 0.567273 6.09091 0 7.54545C1.25818 10.7382 4.36364 13 8 13C9.12727 13 10.2036 12.7818 11.1855 12.3891L11.4982 12.6945L13.6218 14.8182L14.5455 13.8945L1.65091 1M8 3.90909C8.96442 3.90909 9.88935 4.29221 10.5713 4.97416C11.2532 5.65611 11.6364 6.58103 11.6364 7.54545C11.6364 8.01091 11.5418 8.46182 11.3745 8.86909L13.5055 11C14.5964 10.0909 15.4691 8.89818 16 7.54545C14.7418 4.35273 11.6364 2.09091 8 2.09091C6.98182 2.09091 6.00727 2.27273 5.09091 2.6L6.66909 4.16364C7.08364 4.00364 7.52727 3.90909 8 3.90909Z",
    fill: "#373740"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.bbda181e50131ae30a10f015fda23c72.svg";
export { ForwardRef as ReactComponent };